/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.Accountsync {
    export class MeevoUniqueField implements angular.IDirective {
        require = 'ngModel';
        restrict = 'A';
        scope = {    
            checkForUnique: '&',
            alertAction: '&?'
        }
        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: any) => {            
            ngModel.$asyncValidators[attrs['name']] = modelValue => {             
                let deferred = this.$q.defer();
                scope.checkForUnique({changedValue: modelValue}).then(result => {
                    // If this field is unique
                    if (!result) {
                        deferred.resolve();
                    } else {
                        deferred.reject();
                        if (scope.alertAction) scope.alertAction();                        
                    }
                });             

                return deferred.promise;                
            };
        };

        constructor(
            private $q: angular.IQService,
            private dataService: Meevo.Components.BaseClasses.IDataService) {
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($q: angular.IQService, dataService: Meevo.Components.BaseClasses.IDataService) => {
                return new MeevoUniqueField($q, dataService);
            };
            directive.$inject = [
                '$q',
                "meevo.components.common.DataService"
            ];

            return directive;
        }
    }

    angular.module("meevo.plugins.accountsync")
        .directive("meevoUniqueField", MeevoUniqueField.factory());
}